import { useState } from "react";
import {
  IconAlignBoxBottomCenter,
  IconCards,
  IconFileDollar,
  IconInvoice,
  IconLayoutCards,
} from "@tabler/icons-react";
import classes from "./NavbarSimple.module.css";
import ThemeToggle from "../ThemeToggle/ThemeToggle";
import { useFilterReset } from "../TableSort/FilterGroup/FilterResetContext";

const data = [
  {
    link: "",
    label: "Subscription Products",
    icon: IconAlignBoxBottomCenter,
    type: "products",
  },
  { link: "", label: "My Subscriptions", icon: IconLayoutCards, type: "subscriptions" },
  { link: "", label: "My Invoices", icon: IconInvoice, type: "invs" },
  { link: "", label: "My Cards", icon: IconCards, type: "cards" },
  /*{ link: "", label: "My Mandates", icon: IconFileDollar, type: "mandts" },*/
];

export function NavbarSimple({ onSelect }: { onSelect: any }) {
  const [active, setActive] = useState("Subscription Products");
  const { triggerReset } = useFilterReset();

  function handleClick(event: any, item: any) {
    event.preventDefault();
    setActive(item.label);
    console.log("item type navbar", item.type);
    onSelect(item.type);
    triggerReset();
  }

  const links = data.map((item) => (
    <a
      className={classes.link}
      data-active={item.label === active || undefined}
      href={item.link}
      key={item.label}
      onClick={(event) => {
        handleClick(event, item);
      }}
    >
      <item.icon className={classes.linkIcon} stroke={1.5} />
      <span>{item.label}</span>
    </a>
  ));

  return (
    <nav className={classes.navbar}>
      <div className={classes.navbarMain}>
        {/* <Group className={classes.header} justify="space-between">
          <h1>Navbar</h1>
        </Group> */}
        {links}
      </div>

      <div className={classes.footer}>
        <ThemeToggle />
      </div>
      {/* <div className={classes.footer}>
        <a href="#" className={classes.link} onClick={(event) => event.preventDefault()}>
          <IconSwitchHorizontal className={classes.linkIcon} stroke={1.5} />
          <span>Change account</span>
        </a>

        <a href="#" className={classes.link} onClick={(event) => event.preventDefault()}>
          <IconLogout className={classes.linkIcon} stroke={1.5} />
          <span>Logout</span>
        </a>
      </div> */}
    </nav>
  );
}
